var map = {
	"./800-super-Gaea-logo.png": 6938,
	"./About-Us-PNG-HD.png": 4638,
	"./Cintri-cambodia-logo.png": 9677,
	"./ClearCambodiaLogo.jpg": 4466,
	"./ODC-New-logo.png": 1884,
	"./arrows.png": 5527,
	"./how-to-recycle.png": 9555,
	"./information.png": 2550,
	"./logo.webp": 9510,
	"./mizuda-logo.jpg": 81,
	"./trust-comm-members.png": 8862,
	"./waste-summit-cambodia-logo.png": 287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4403;